import { useContext, useMemo } from 'react';
import RouteContext from '../../routes/context';

type AggregationSettings = {
  id: string;
  size: number;
  query?: string;
};

export const useAggregationSettings = (
  id: string
): AggregationSettings | undefined => {
  const { getState } = useContext(RouteContext);
  const { aggregations }: { aggregations: AggregationSettings[] } = getState();

  return useMemo(
    () =>
      aggregations?.length
        ? aggregations.find(agg => agg.id === id)
        : undefined,
    [aggregations, id]
  );
};
